import {ReactElement, ReactNode} from 'react'
import {TableSortLabel} from '@material-ui/core'
import {SortApi} from '../../../../../../../shared/hooks/useSort'

type TableSortCellProps<T extends string> = {
  orderBy: T
  sortApi: SortApi<T>
  children: ReactNode
}

export function TableSortCell<T extends string>(props: TableSortCellProps<T>): ReactElement {
  const {orderBy, sortApi, children} = props

  const isActive = orderBy === sortApi.value.orderBy
  const direction = sortApi.value.orderDirection.toLowerCase() as 'asc' | 'desc'

  const handleClick = (): void => {
    if (isActive) {
      sortApi.change((prevSort) => {
        const nextDirection = prevSort.orderDirection === 'ASC' ? 'DESC' : 'ASC'
        return {...prevSort, orderDirection: nextDirection}
      })
    } else {
      sortApi.change({orderBy, orderDirection: 'DESC'})
    }
  }

  return (
    <TableSortLabel
      active={isActive}
      direction={isActive ? direction : 'desc'}
      onClick={handleClick}
    >
      {children}
    </TableSortLabel>
  )
}
